import React, { useEffect, useState } from 'react';
import { GetSelfSignupStatusResult } from './models';

export function ManageSelfSignupView(): JSX.Element {
  const [error, setError] = useState<string>();
  const [selfSignupEnabled, setSelfSignupEnabled] = useState<boolean>();

  useEffect(() => {
    getSelfSignupStatus().then((result) => {
      const error = result.error;
      if (error) {
        setError(error);
      } else {
        const { enabled } = result;
        setSelfSignupEnabled(enabled);
      }
    });
  }, []);

  const switchSelfSignupStatus = async (newValue: boolean) => {
    const response = await fetch('/admin/self-signup-status', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ enabled: newValue })
    });

    if (response.status === 500) {
      const { error } = await response.json();
      setError(error);
      return;
    }
    window.location.reload();
  };

  return <div className='container'>
    {
      error &&
        <div className='notification is-danger mb-2 p-3'>
          {error}
        </div>
    }
    <h1 className='title'>
      Manage Self Signup
    </h1>
    <label className='checkbox has-text-weight-bold'>
      <input
        checked={selfSignupEnabled}
        type='checkbox'
        className='mr-1'
        onChange={(evt) => switchSelfSignupStatus(evt.target.checked)}
      />
      Turn on self-signup
    </label>
  </div>;
}

async function getSelfSignupStatus(): Promise<GetSelfSignupStatusResult> {
  const response = await fetch('/admin/self-signup-status');
  return await response.json();
}